<template>
  <div>
    <loader style="z-index: 99999999" />
    <div class="login-wrap">
      <div class="login-container">
        <div class="login-main">
          <!--<div class="login-brand">ƒ(dB)K</div>-->
          <div class="login-form">
            <!--<h2 class="login-form-title">Logga in på ƒ(dB)k</h2>-->
            <div class="login-form-title"><img style="width: 100%" src="/static/images/login-logo-landscape.svg"></div>

            <slot />
          </div>
        </div>
        <div class="login-sidebar" v-if="displayDownloadOptions()">
          <h2 class="login-sidebar-title">Ladda ner klient</h2>

          <a :href="downloadUrl" type="button" class="client-button" download>
            <i class="fab fa-windows client-button-icon"></i> Windows
          </a>

          <!--
          <button type="button" class="client-button">
            <i class="fab fa-apple client-button-icon"></i> Mac
          </button>

          <button type="button" class="client-button">
            <i class="fab fa-linux client-button-icon"></i> Linux
          </button>
          -->

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Loader from '@/components/actions/Loader'

export default {
  components: {
    Loader
  },

  computed: {
    downloadUrl: () => `${process.env.ROOT_API}/dlc/fdbk-setup.exe`.replace('/v1', '')
  },

  methods: {
    displayDownloadOptions () {
      return !this.isElectron()
    },
    isElectron () {
      return window.isElectron()
    },
    rootApi () {
      return process.env.ROOT_API
    },
    nodeEnv () {
      return process.env.NODE_ENV
    }

    /*
    downloadElectronClient () {
      this.$axios({
        url: 'http://localhost:5000/static/example.pdf',
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.pdf')
        document.body.appendChild(link)
        link.click()
      })
    }
    */
  },

  created () {
    // alert(window.Bridge.kuk())
    // alert('window.electronAPI', window.electronAPI)
    // alert('window.electronAPI.getPath()', window.electronAPI.getPath())
    // alert(window.electronAPI.getPath())
    // alert(window.electronAPI.getPath())
    // alert(window.electronAPI.getPath())
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/LoginLayout.vue